<template>
  <div>
    <hshead title="店铺客户" waveBg="true"></hshead>
    <div class="tabs-box">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="酒店列表">
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
        </van-tab>
        <van-tab title="协议列表">
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
          <van-cell-group>
            <van-cell title="单元格" value="内容" label="描述信息" />
          </van-cell-group>
        </van-tab>
      </van-tabs>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item icon="orders-o">商品管理</van-tabbar-item>
      <van-tabbar-item icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Tab, Tabs, List,Tabbar, TabbarItem,Cell, CellGroup  } from "vant";
export default {
  name: "photographer",
  data() {
    return {
      list: [],
      tabactive: 0,
      active: 4,
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-list": List,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    'van-cell':Cell,
    'van-cell-group':CellGroup
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.tabs-box {
  margin-top: -4.3rem;
}

</style>


// WEBPACK FOOTER //
// src/components/shopCustomers.vue